import InternalStaticAnchorNewsList from 'models/application/anchor/types/internalStatic/types/NewsList';

export default class InternalStaticAnchorNewsListService {
	toModel(anchor) {
		return new InternalStaticAnchorNewsList(anchor);
	}
}
